import { decimalToPercentage, numberToText } from "./transformators.js";

// Ignore Enter Key, showCalculator on Enter, and Arrow Navigation
export const ignoreEnter = (e, setShowcalculator, showcalculator) => {
  if (e.key === "Enter") {
    e.preventDefault();
    const calculatorMap = {
      insurancecost: "insurance",
      importcustomsfee: "importcustomsfee",
      inboundcost: "inboundcost",
      outboundcost: "outboundcost",
      freightpmt: "oceanfreight",
    };
    if (calculatorMap[e.target.name]) {
      setShowcalculator(calculatorMap[e.target.name]);
    }
    if (showcalculator) {
      setShowcalculator("");
    }
  } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    const nextElement = e.key === "ArrowDown" ? form.elements[index + 1] : form.elements[index - 1];
    if (nextElement) {
      nextElement.focus();
    }
  }
};

// Figure input change
export const handleFigureChange = (
  e,
  figuretype,
  setValues,
  setData,
  setEditing,
  inEuros = false,
  ERate = 1,
  dec = 4
) => {
  setEditing(true);
  if (figuretype === "currency") {
    console.log(inEuros);
    const isCurrency = RegExp("^[$€]{0,1}[0-9]*[.]{0,1}[0-9%]*$");
    if (isCurrency.test(e.target.value) || e.target.value === "") {
      const rawValue = Number(e.target.value.replace(/[$€,]/g, "")) || 0;
      // Convert to USD for storage if in Euro mode
      const valueInUSD = inEuros ? rawValue / ERate : rawValue;
      setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setData((prev) => ({
        ...prev,
        [e.target.name]: Number(valueInUSD.toFixed(dec)),
        // [e.target.name]: Number(Number(e.target.value.replace(",", "").replace("$", "")).toFixed(dec)),
      }));
    }
  }
  if (figuretype === "decimal") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setData((prev) => ({
        ...prev,
        [e.target.name]: Number(Number(e.target.value).toFixed(dec)),
      }));
    }
  }
  if (figuretype === "percent") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (e.target.value.toString().includes("%")) {
        setData((prev) => ({
          ...prev,
          [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
        }));
        setValues((prev) => ({
          ...prev,
          [e.target.name]: e.target.value.replace("%", ""),
        }));
      } else {
        setData((prev) => ({
          ...prev,
          [e.target.name]: Number(e.target.value).toFixed(dec) / 100,
        }));
        setValues((prev) => ({
          ...prev,
          [e.target.name]: e.target.value,
        }));
      }
    }
  }
  if (figuretype === "integer") {
    const isInteger = RegExp("^[0-9]+$");
    if (isInteger.test(e.target.value) || e.target.value === "") {
      setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
      setData((prev) => ({
        ...prev,
        [e.target.name]: Number(e.target.value),
      }));
    }
  }
  if (figuretype === "text") {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }
};

//Figure Input Blur
export const handleFigureBlur = (
  e,
  figuretype,
  setValues,
  currentEdits,
  editID,
  setEditID,
  editingField,
  setEditingField,
  undoList,
  inEuros = false,
  ERate = 1,
  dec = 2
) => {
  // console.log(editID);
  const symbol = inEuros ? "€" : "$";
  const rawValue = Number(e.target.value.replace(/[$€,]/g, "")) || 0;
  const valueInUSD = inEuros ? rawValue / ERate : rawValue;

  if (figuretype === "currency") {
    // Display formatted value in selected currency
    const formattedDisplay =
      symbol +
      Number(rawValue)
        .toFixed(dec)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    setValues((prev) => ({ ...prev, [e.target.name]: formattedDisplay }));
    // setValues((prev) => ({
    //   ...prev,
    //   [e.target.name]:
    //     "$" +
    //     Number(e.target.value.replace(",", "").replace("$", ""))
    //       .toFixed(dec)
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    // }));
    if (editingField) {
      currentEdits.current.push({
        editID: editID,
        name: e.target.name,
        // value: Number(e.target.value.replace("$", "")).toFixed(dec),
        value: formattedDisplay,
        num: Number(valueInUSD.toFixed(dec)),
        // num: Number(Number(e.target.value.replace("$", "")).toFixed(dec)),
        figuretype: "currency",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(currentEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "decimal") {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: Number(e.target.value.replace("$", "")).toFixed(dec),
    }));
    // console.log(editingField);
    if (editingField) {
      currentEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(e.target.value.replace("$", "")).toFixed(dec),
        num: Number(Number(e.target.value).toFixed(dec)),
        figuretype: "decimal",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(currentEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "percent") {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
    }));
    if (editingField) {
      currentEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
        num: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
        figuretype: "percent",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
      // console.log(currentEdits.current);
      // console.log(undoList.current);
    }
  }
  if (figuretype === "integer") {
    console.log(Number(Number(e.target.value.replace("$", "")).toFixed(0)));
    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value === "" ? "" : Number(Number(e.target.value.replace("$", "")).toFixed(0)),
    }));
    if (editingField) {
      currentEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: Number(Number(e.target.value.replace("$", "")).toFixed(0)),
        num: Number(e.target.value),
        figuretype: "integer",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
    }
  }
  if (figuretype === "text") {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (editingField) {
      currentEdits.current.push({
        editID: editID,
        name: e.target.name,
        value: e.target.value,
        num: e.target.value,
        figuretype: "text",
      });
      setEditID((prev) => prev + 1);
      setEditingField(false);
      undoList.current = [];
    }
  }
};

// Add Edits
export const addEdits = (item, currentEdits, editID, setEditID, ...fieldNames) => {
  // Add edits to currentEdits ref
  fieldNames.forEach((field, i) => {
    if (item[field] !== undefined) {
      currentEdits.current.push({
        editID: editID,
        nameID: field + "ID",
        valueID: item[field + "ID"],
        name: field,
        value: item[field],
      });
    }
    setEditID((prev) => prev + 1);
  });
  // console.log(item);
  // console.log(currentEdits.current);

  // enforce max length = 50
  // if (currentEdits.current.length > 50) {
  //   currentEdits.current = currentEdits.current.slice(-50);
  // }
};

// ProdSupplier
export const handleProductSelect = (item, setValues, setData, currentEdits, addEdits, editID, setEditID, undoList) => {
  setValues((prev) => ({
    ...prev,
    ["product"]: item.product,
    ["supplier"]: item.supplier,
  }));
  setData((prev) => ({
    ...prev,
    ["productID"]: item.productID,
    ["supplierID"]: item.supplierID,
  }));
  // if (positiontoedit) {
  addEdits(item, currentEdits, editID, setEditID, "product", "supplier");
  undoList.current = [];

  // }
  // console.log(positionEdits.current);
};

// handle input Select
export const handleInputSelect = (
  item,
  currentEdits,
  editID,
  setEditID,
  setValues,
  setData,
  addEdits,
  undoList,
  originname,
  destinationname,
  globalparams
) => {
  setValues((prev) => ({
    ...prev,
    [destinationname]: item[originname],
  }));
  setData((prev) => ({
    ...prev,
    [destinationname + "ID"]: item[originname + "ID"],
  }));

  addEdits(item, currentEdits, editID, setEditID, destinationname);
  const insuranceRates = {
    DAP: { rate: globalparams?.DAPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIP: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIF: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CPT: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CFR: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
  };
  if (destinationname === "sincoterm") {
    console.log(globalparams);
    const { rate, factor } = insuranceRates[item["sincoterm"]] || { rate: 0, factor: 0 };
    currentEdits.current.push({
      name: "insurancerate",
      value: decimalToPercentage(rate),
      num: rate,
      editID: editID,
    });

    currentEdits.current.push({
      name: "insurancefactor",
      value: numberToText(factor),
      num: factor,
      editID: editID,
    });
  }
  undoList.current = [];
};

// Handle paymentterm input changes
export const handlePaytermInputChange = (
  ind,
  el1,
  e,
  paymentterm,
  paymenttermData,
  setPaymentterm,
  setPaymenttermData,
  setEditingField
) => {
  setEditingField(true);
  const temp = paymentterm[ind];
  const tempdata = paymenttermData[ind];
  let value;
  let num;
  if (el1 === "portion") {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (e.target.value.toString().includes("%")) {
        value = e.target.value.replace("%", "");
        num = Number(e.target.value.replace("%", "")).toFixed(2);
      } else {
        value = e.target.value;
        num = Number(e.target.value).toFixed(2) / 100;
      }
    }
  } else if (el1 === "termdays") {
    const isInteger = RegExp("^[0-9]+$");
    if (isInteger.test(e.target.value) || e.target.value === "") {
      value = e.target.value;
      num = Number(e.target.value);
    }
  }
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, [e.target.name]: value } : item)));
  setPaymenttermData((prev) =>
    prev.map((item) => (item.row === tempdata.row ? { ...item, [e.target.name]: num } : item))
  );
};

// Handle Payment Term Input Blur
export const handlePaytermInputBlur = (
  ind,
  el1,
  e,
  paymentterm,
  setPaymentterm,
  currentEdits,
  editingField,
  editID,
  setEditID,
  setEditingField,
  undoList,
  paymenttermData,
  origin
) => {
  const temp = paymentterm[ind];
  const tempData = paymenttermData[ind];
  let value;
  let num;
  if (el1 === "portion") {
    // temp[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) + "%";
    // tempData[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) / 100;
    value = Number(e.target.value.replace("%", "")).toFixed(2) + "%";
    num = Number(e.target.value.replace("%", "")).toFixed(2) / 100;
  }
  if (el1 === "termdays") {
    value = e.target.value;
    num = Number(e.target.value);
  }
  if (editingField) {
    currentEdits.current.push({
      editID: editID,
      // name: e.target.id,
      name: origin + e.target.name + (temp.posPaytermID || temp.row),
      value: value,
      num: num,
      figuretype: el1,
      ind: ind,
      temp: temp,
      tempData: tempData,
      row: temp.posPaytermID || temp.row,
      origin: origin,
    });
    // console.log(positionEdits.current);
    setEditID((prev) => prev + 1);
    setEditingField(false);
    undoList.current = [];
  }
  // console.log(positionEdits.current);
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, [e.target.name]: value } : item)));
};

// Handle PayType Selection
export const SelectPayType = (
  item,
  ind,
  paymentterm,
  setPaymentterm,
  paymenttermData,
  setPaymenttermData,
  editingField,
  positionEdits,
  editID,
  el1,
  setEditID,
  setEditingField,
  undoList,
  origin
) => {
  // console.log("before", positionEdits.current);
  const temp = paymentterm[ind];
  const tempData = paymenttermData[ind];
  temp["payType"] = item.payType;
  tempData["payTypeID"] = item.payTypeID;
  setPaymentterm((prev) => prev.map((item) => (item.row === temp.row ? { ...item, ["payType"]: item.payType } : item)));
  setPaymenttermData((prev) =>
    prev.map((item) => (item.row === tempData.row ? { ...item, ["payTypeID"]: item.payTypeID } : item))
  );
  // if (editingField) {
  positionEdits.current.push({
    editID: editID,
    name: origin + el1 + (temp.posPaytermID || temp.row),
    value: item.payType,
    num: item.payTypeID,
    figuretype: "payType",
    ind: ind,
    // temp: temp,
    // tempData: tempData,
    row: temp.posPaytermID || temp.row,
    origin: origin,
  });
  // console.log("after", positionEdits.current);
  setEditID((prev) => prev + 1);
  // setEditingField(false);
  undoList.current = [];
  // }
};

export const handleDelPayRow = (
  paymentterm,
  paymenttermData,
  setPaymentterm,
  setPaymenttermData,
  setReloadpayterms,
  ind,
  currentEdits,
  editID,
  setEditID,
  undoList,
  payrow,
  loadedPayterm,
  loadedPaytermData,
  origin
) => {
  let temp = structuredClone(paymentterm[ind]);
  let tempData = structuredClone(paymenttermData[ind]);

  if (paymentterm.length > 1) {
    setPaymentterm((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
    setPaymenttermData((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
  }

  currentEdits.current.push({
    editID: editID,
    figuretype: "delpayrow",
    ind: ind,
    temp: temp,
    tempData: tempData,
    name: origin + "delrow" + temp.row,
    row: temp.row,
    origin: origin,
  });
  setEditID((prev) => prev + 1);
  undoList.current = [];
};

export const handleAddPayRow = (
  setPaymentterm,
  setPaymenttermData,
  payrow,
  currentEdits,
  editID,
  setEditID,
  undoList,
  loadedPayterm,
  loadedPaytermData,
  qstoedit,
  origin
) => {
  payrow.current = payrow.current + 1;
  // console.log(payrow.current);
  setPaymentterm((prev) => [
    ...prev,
    {
      row: payrow.current,
      portion: "0.00%",
      payType: "CAD",
      termdays: "10",
      type: "new",
      QSPaytermID: qstoedit || null,
    },
  ]);
  setPaymenttermData((prev) => [
    ...prev,
    { row: payrow.current, portion: 0, payTypeID: 1, termdays: 10, type: "new", positionID: qstoedit || null },
  ]);
  loadedPayterm.current.push({
    row: payrow.current,
    portion: "0.00%",
    payType: "CAD",
    termdays: "10",
    type: "new",
    QSPaytermID: qstoedit || null,
  });
  loadedPaytermData.current.push({
    row: payrow.current,
    portion: 0,
    payTypeID: 1,
    termdays: 10,
    type: "new",
    QSPaytermID: qstoedit || null,
  });
  currentEdits.current.push({
    editID: editID,
    name: origin + "addrow" + payrow.current,
    figuretype: "addpayrow",
    row: payrow.current,
    QSPaytermID: qstoedit || null,
    origin: origin,
  });
  setEditID((prev) => prev + 1);
  undoList.current = [];
  // console.log(positionEdits.current);
};
